import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandMark from './BrandMark';
import '../styles/Header.css';

interface NavItem {
  label: string;
  to: string;
}

/**
 * Each nav item targets a dedicated route so the URLs are real (SEO + Google
 * Ads sitelinks). The homepage still renders the matching sections with their
 * historical ids — `/#help`, `/#place`, `/#contact` continue to resolve via
 * <ScrollToTop /> for any legacy inbound links.
 */
const NAV_ITEMS: NavItem[] = [
  { label: 'Adotar', to: '/adotar' },
  { label: 'Ajudar', to: '/ajudar' },
  { label: 'Visitar', to: '/onde-estamos' },
  { label: 'Sobre', to: '/sobre' },
  { label: 'Transparência', to: '/transparencia' },
  { label: 'Contacto', to: '/contactos' },
];

const MENU_ID = 'psl-nav-menu';

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the drawer whenever the route changes (a nav link was followed).
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Close on Escape while open.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <nav className={`psl-nav${open ? ' is-open' : ''}`} aria-label="Principal">
      <Link
        to="/"
        className="psl-nav__brand"
        aria-label="Patinhas Sem Lar — Início"
      >
        <BrandMark className="psl-nav__mark" />
      </Link>

      <button
        type="button"
        className="psl-nav__toggle"
        aria-expanded={open}
        aria-controls={MENU_ID}
        aria-label={open ? 'Fechar menu' : 'Abrir menu'}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="psl-nav__toggle-bar" aria-hidden="true" />
        <span className="psl-nav__toggle-bar" aria-hidden="true" />
        <span className="psl-nav__toggle-bar" aria-hidden="true" />
      </button>

      <ul id={MENU_ID} className="psl-nav__list">
        {NAV_ITEMS.map((item) => (
          <li key={item.label}>
            <Link to={item.to} onClick={() => setOpen(false)}>
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Header;
